import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ParseUrlService {

  constructor(private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: object) { }

  getParamsObjectFromHash(): any {
    let toBeReturned = {};
    if(window && isPlatformBrowser(this.platformId)){
    const hash = window.location.hash ? window.location.hash.split('#') : [];
    if (hash.length && hash[1].split('&').length) {
      toBeReturned = hash[1].split('&').reduce((acc:any, x) => {
        const hello = x.split('=');
        if (hello.length === 2){
        acc[hello[0]] = hello[1];
          return acc;
        }
      }, {});
    }
  }
    return Object.keys(toBeReturned).length ? toBeReturned : null;
  }




    // Vrátí Observable s objektem parametrů z fragmentu URL
   /* getParamsObjectFromHash() {
      return this.route.fragment.pipe(
        filter(fragment => !!fragment),
        map(fragment => {
          const params = new URLSearchParams(fragment!); // Předpokládáme, že fragment není null
          const paramsObj: any = {};
          params.forEach((value, key) => {
            paramsObj[key] = value;
          });
          return paramsObj;
        })
      );
    }*/
}
